import { render, staticRenderFns } from "./ead-avaliacao-conteudo.vue?vue&type=template&id=a67ddf82&scoped=true&"
import script from "./ead-avaliacao-conteudo.vue?vue&type=script&lang=js&"
export * from "./ead-avaliacao-conteudo.vue?vue&type=script&lang=js&"
import style0 from "./ead-avaliacao-conteudo.vue?vue&type=style&index=0&id=a67ddf82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67ddf82",
  null
  
)

export default component.exports